import { User } from './user.type'

export type PlatformConfig = {
  id: string
  name: string
  value: string
  updatedByUserId: string
  createdAt: string
  updatedAt: string

  // Optional
  updatedByUser: User
}

export enum PlatformConfigName {
  BANNER_MAIN = 'banner_main',
  BANNER_MARKET = 'banner_market',

  REFERRAL_PERCENT = 'referral_percent',

  PLATFORM_FEE = 'platform_fee',
}
